<template>
  <div class="list-container">
    <div class="title">
      <span v-if="type === 'notice'">通知公告</span>
      <span v-if="type === 'Trends'">学术动态</span>
      <div class="title-line"></div>
    </div>
    <div class="table" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
      <div
        class="item"
        v-for="(item, index) in noticeList"
        :key="item.id"
        :style="{ animationDelay: index * 0.06 + 's' }"
        @click="routerTo(`/detail`, item)"
      >
        <div class="item-left">
          <div class="item-dot"></div>
          <div class="item-title">{{ item.title }}</div>
        </div>
        <div class="item-date">
          <i class="el-icon-time"></i>
          {{ formatTimeStamp(item.createdTime*1000) }}
        </div>
      </div>
      <div v-if="!loading && noticeList.length === 0" class="empty-tip">
        <i class="el-icon-document-delete"></i>
        <p>暂无数据</p>
      </div>
    </div>
    <div class="pagination" v-if="total > 0">
      <el-pagination
        @current-change="currentChange"
        :total="total"
        :current-page="currPage"
        :page-size="pageSize"
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getNoticePage, getAcademicTrendPage} from '@/api/api'

export default {
  data () {
    return {
      type: '',
      total: 1000,
      currPage: 1,
      pageSize: 20,
      noticeList: [],
      loading: false
    }
  },
  created () {
    const type = this.$route.query.type
    this.type = type
    this.getNoticePage()
  },
  methods: {
    currentChange (e) {
      this.currPage = e
      this.getNoticePage()
    },
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    getNoticePage () {
      this.loading = true
      let data = {
        pageSize: this.pageSize,
        currPage: this.currPage
      }
      let apiPromise = null
      if (this.type === 'notice') {
        apiPromise = getNoticePage(data)
      } else if (this.type === 'Trends') {
        apiPromise = getAcademicTrendPage(data)
      }
      if (apiPromise) {
        apiPromise.then(res => {
          if (res.code === 200) {
            this.noticeList = res.data.list
            this.total = res.data.totalCount
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    formatTimeStamp (timeStamp) {
      let date = new Date(timeStamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  }
}
</script>

<style scoped>
.list-container {
  min-height: 400px;
}

.title {
  position: relative;
  letter-spacing: 2px;
  font-size: 30px;
  line-height: 2em;
  color: #2f4f4f;
  font-weight: bold;
  padding-bottom: 8px;
  animation: titleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes titleFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
    letter-spacing: 8px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 2px;
  }
}

.title-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: #2f4f4f;
  border-radius: 2px;
  animation: lineExpand 1s cubic-bezier(0.22, 1, 0.36, 1) 0.4s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineExpand {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.table {
  margin-top: 24px;
  border: 2px solid rgba(47, 79, 79, 0.15);
  border-radius: 12px;
  padding: 16px 24px;
  box-sizing: border-box;
  min-height: 200px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(47, 79, 79, 0.06);
  animation: tableFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s forwards;
  opacity: 0;
  transform: translateY(20px);
}

@keyframes tableFadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.item {
  position: relative;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  color: #444;
  padding: 0 12px;
  border-radius: 8px;
  opacity: 0;
  animation: itemSlideIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
  overflow: hidden;
}

@keyframes itemSlideIn {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.item + .item {
  border-top: 1px solid rgba(47, 79, 79, 0.08);
}

.item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 3px;
  height: 60%;
  background: #2f4f4f;
  border-radius: 0 3px 3px 0;
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.item:hover {
  cursor: pointer;
  color: #2f4f4f;
  background: rgba(47, 79, 79, 0.04);
  transform: translateX(6px);
  box-shadow: 0 2px 12px rgba(47, 79, 79, 0.08);
}

.item:hover::before {
  transform: translateY(-50%) scaleY(1);
}

.item-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.item-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(47, 79, 79, 0.3);
  transition: all 0.35s ease;
  flex-shrink: 0;
}

.item:hover .item-dot {
  background: #d4af37;
  transform: scale(1.5);
  box-shadow: 0 0 8px rgba(212, 175, 55, 0.4);
}

.item-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-date {
  color: #999;
  font-size: 13px;
  font-weight: 400;
  flex-shrink: 0;
  margin-left: 16px;
  transition: color 0.35s ease;
}

.item:hover .item-date {
  color: #2f4f4f;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 28px;
  animation: paginationFadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.6s forwards;
  opacity: 0;
}

@keyframes paginationFadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.empty-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #bbb;
  font-size: 14px;
  animation: emptyFadeIn 0.5s ease forwards;
}

.empty-tip i {
  font-size: 48px;
  margin-bottom: 12px;
  color: #ddd;
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
